<template>
  <div class="addressEdit addressEdit--a">
    <AddressEdit
      :area-list="areaList"
      :show-postal="false"
      show-delete
      show-set-default
      show-search-result
      :search-result="searchResult"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      :address-info="address"
      @save="onSave"
      @delete="onDelete"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
import { AddressEdit, Toast } from "vant";
import { initOpenid } from "@/utils/getOpenid";
import { areaList } from "@vant/area-data";
import {
  addressAdd,
  addressDelete,
  addressEdit,
} from "@/api/officialAccount/index.js";

export default {
  components: { AddressEdit },
  data() {
    return {
      areaList,
      searchResult: [],
      address: {},
      projectId: null,
    };
  },
  created() {
    if (
      process.env.NODE_ENV === "development" &&
      !localStorage.getItem("openId")
    ) {
      localStorage.setItem("openId", "dev_test_openid");
    }
    if (!localStorage.getItem("openId")) initOpenid();
    if (this.$route.query.address) {
      console.log(JSON.parse(this.$route.query.address));
      const queryaddress = JSON.parse(this.$route.query.address);
      this.projectId = queryaddress.id;
      this.address = JSON.parse(JSON.stringify(queryaddress));
      console.log(this.address);
    }
  },
  mounted() {
    console.log(location.href);
    var box = document.getElementsByClassName("van-address-edit__buttons");
    console.log(box);
    var div = document.createElement("div");
    div.innerText = "返回";
    div.style.width = "100%";
    div.style.height = "40px";
    div.style.background = "#fff";
    div.style.borderRadius = "400px";
    div.style.textAlign = "center";
    div.style.lineHeight = "40px";
    div.style.color = "#323233";
    div.style.fontSize = "14px";
    div.onclick = () => {
      this.$router.push({ name: "addressMana" });
    };
    box[0].appendChild(div);
  },
  methods: {
    async addressAddHanlde() {
      const { code } = await addressAdd({
        city: this.address.city,
        detail: this.address.addressDetail,
        name: this.address.name,
        openid: localStorage.getItem("openId"),
        phone: this.address.tel,
        province: this.address.province,
        type: this.address.isDefault ? 1 : 0,
        code: this.address.areaCode,
        area: this.address.county,
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "添加成功" },
      });
      // this.push('')
    },
    async addressEditHanlde() {
      const { code } = await addressEdit({
        city: this.address.city,
        detail: this.address.addressDetail,
        name: this.address.name,
        id: this.projectId,
        phone: this.address.tel,
        province: this.address.province,
        type: this.address.isDefault ? 1 : 0,
        code: this.address.areaCode,
        area: this.address.county,
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "修改成功" },
      });
      // this.push('')
    },
    async addressDelete() {
      const { code } = await addressDelete({
        id: this.projectId,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "删除成功" },
      });
    },
    onSave(val) {
      console.log(val);
      this.address = val;
      if (!localStorage.getItem("openId")) {
        Toast("请重新加载页面");
        return;
      }
      if (this.projectId) {
        this.addressEditHanlde();
      } else {
        this.addressAddHanlde();
      }
    },
    onDelete(val) {
      console.log(val);
      this.address = val;
      if (!localStorage.getItem("openId")) {
        Toast("请重新加载页面");
        return;
      }
      if (!this.projectId) return;
      this.addressDelete();
    },
    onChangeDetail(val) {
      console.log(val);
      // if (val) {
      //   this.searchResult = [
      //     {
      //       name: '黄龙万科中心',
      //       address: '杭州市西湖区',
      //     },
      //   ];
      // } else {
      //   this.searchResult = [];
      // }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-switch--on {
  background-color: #60bb46;
}
/deep/.van-button--danger {
  background-color: #60bb46;
  border-color: #60bb46;
}
/deep/.van-address-edit__buttons .van-button {
  margin-bottom: 20px;
}
// /deep/.van-button--default {
//   background-color: #ee0a24;
//   color: #fff;
// }
</style>

<!--
  改版方案 A（2026-09-22）：分组列表。只改样式和布局，文字不动。
  回退：去掉模板根节点上的 addressEdit--a。
-->
<style lang="less" scoped>
@a-bg: #f2f2f7;
@a-card: #fff;
@a-line: #e9e9ee;
@a-ink: #1c1c1e;
@a-sub: #8a8a8e;
@a-green: #60bb46;
@a-green-text: #3f9a2e;
@a-radius: 12px;

.addressEdit--a {
  min-height: 100vh;
  background: @a-bg;
  color: @a-ink;

  /deep/ .van-address-edit {
    padding: 14px 16px;
  }
  // 表单字段、默认地址开关各为一张圆角卡片
  /deep/ .van-address-edit__fields,
  /deep/ .van-address-edit__default {
    border-radius: @a-radius;
    overflow: hidden;
    background: @a-card;
  }
  /deep/ .van-address-edit__default {
    margin-top: 14px;
  }
  /deep/ .van-cell {
    padding: 12px 16px;
    font-size: 15px;
  }
  // 详细地址是 cell 里再套一个 field，外层不要再加内边距，否则和上面几行对不齐
  /deep/ .van-address-edit-detail {
    padding: 0;
  }
  /deep/ .van-cell::after {
    left: 16px;
    right: 0;
    border-bottom-color: @a-line;
  }
  /deep/ .van-field__label {
    color: @a-ink;
  }
  /deep/ .van-address-edit__buttons {
    padding: 24px 0 calc(16px + env(safe-area-inset-bottom, 0px));
  }
  /deep/ .van-address-edit__buttons .van-button {
    height: 46px;
    margin-bottom: 10px;
    border-radius: @a-radius;
    font-size: 16px;
    font-weight: 600;
  }
  /deep/ .van-address-edit__buttons .van-button--default {
    border: none;
    color: #d93025;
  }
  // 页面脚本插入的「返回」按钮（带行内样式，需 !important）
  /deep/ .van-address-edit__buttons > div {
    height: 46px !important;
    border-radius: @a-radius !important;
    line-height: 46px !important;
    font-size: 16px !important;
    font-weight: 600;
  }
}
</style>
